/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExcelConnectionConfig } from '../../models/excel-connection-config';

export interface GetExcelConnectionConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected excel connection configuration
 */
  excelUid: string;
}

export function getExcelConnectionConfigurations(http: HttpClient, rootUrl: string, params: GetExcelConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfig>> {
  const rb = new RequestBuilder(rootUrl, getExcelConnectionConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('excelUid', params.excelUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExcelConnectionConfig>;
    })
  );
}

getExcelConnectionConfigurations.PATH = '/stations/{uid}/excel/{excelUid}';
